import './CauseAndEffectThumbnail.scss';
import CauseAndEffectThumbnailComponent from './thumbnail/CauseAndEffectThumbnailComponent';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';

/**
 * Lesson activity for Cause and Effect
 */
const defaultProps = {
  effectCards: [],
  causeCards: [],
  isSmallThumbnail: false,
};
export default function CauseAndEffectThumbnail(props) {
  const { causeCards, effectCards, isSmallThumbnail } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className={`cause-and-effect-thumbnail ${isSmallThumbnail ? 'small' : ''} cause-length-${causeCards.length} vizzle-cause-and-effect-card-thumbnail`}>
      {causeCards.map((cc, index) => (
        <CauseAndEffectThumbnailComponent
          key={`cause-and-effect-thumbnail-${index}`}
          causeCard={cc}
          effectCard={effectCards[index]}
          isSmallThumbnail={isSmallThumbnail}
        />
      ))}
    </div>
  );
}
